export default __webpack_public_path__ + "static/media/groundPart10.d548ebb1.png";